import { Height } from "@mui/icons-material";
import zIndex from "@mui/material/styles/zIndex";

export const headingStyles = {
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "40px",
    lineHeight: "60px",
    color: "rgb(30, 102, 171)",
    mb: 1,
}
export const defaultButtonStyles = {
    mt: 0,
    mb: 2,
    p: 1,
    textTransform: 'none',
    whiteSpace: 'nowrap'
}
export const subPageHeadingStyles = { fontSize: "20px", color: "#1e66ab", fontWeight: "bold" }
export const subHeadingStyles = {
    color: "#1e66ab", fontWeight: "bold", mb: 1
}
export const NoDataMatchStyles = {
    color: '#1e66ab',
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
}
export const commonHeaderStyle = {
    '& th': {
        fontSize: '16px',
        fontWeight: 'bold',
        border: '1px solid rgba(0, 0, 0, 0.04)',
        backgroundColor: '#92d050',
        position: 'sticky',
        top: 0,
        zIndex: 2

    },
};

export const commonRowStyle = {
    '& td': {
        fontSize: '14px',
        border: '1px solid rgba(0, 0, 0, 0.04)',
        color: '#1e66ab'
    },
};
const tabStyle = {
    textTransform: "none",
    minHeight: "48px",
    height: "48px",
    px: 4,
    borderRadius: "25px",
    fontSize: "16px",
    fontWeight: 500,
    backgroundColor: "#ffffff",
    color: "#555",
    border: "1px solid #e0e0e0",

    "&:hover": {
        backgroundColor: "#f1f7ff",
    },

    "&.Mui-selected": {
        backgroundColor: "#1976d2",
        color: "#fff",
        border: "1px solid #1976d2",
    },
};
export const commonHeaderStyle2 = {
    '& th': {
        fontSize: '16px',
        fontWeight: 'bold',
        border: '1px solid rgba(0, 0, 0, 0.04)',
        backgroundColor: '#92d050',
    },
};
export const NoDataMatchStylesAFP = {
    color: '#1e66ab',
    fontSize: '14px',
}
export const FeestageLevelStyles = {
    background: "#f3f3f3",
    color: "#1e66ab",
    fontSize: "14px",
}
export const SubCategoryLevelStyles = {

    background: "#f3f3f3",
    fontWeight: 600,
    color: "#1e66ab",
    fontSize: "14px",
    pl: 4

}
export const CategoryLevelStyles = {

    background: "#f3f3f3",
    fontWeight: 600,
    color: "#1e66ab",
    fontSize: "15px",


}
export const HeaderStyles = {
    fontSize: "16px",
    fontWeight: "bold",
    border: "1px solid rgba(0,0,0,0.04)",
    backgroundColor: "#92d050",
    position: "sticky",
    top: 0,
    zIndex: 2,
    whiteSpace: "nowrap",
    width: "auto",
    minWidth: "fit-content",
}
export const TotalCostStyles = {
    background: "#f3f3f3",
    fontWeight: 700,
    color: "#1e66ab",
    fontSize: "18px"
}